var twig = require("twig").twig,
    template = twig({"id":"d53da2212edee091fdf24ce1c2ca492a3337ac20a16e4c3b2d601fd3d97417c20bbb4912309b1d993937a09964114023dfc23841c1bade897d5718a343b6e7f1","data":[{"type":"raw","value":"<div class=\"yandex-map__dot-marker\"></div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }